import React, {memo} from 'react';
import 'datatables.net';
import "../../index.css";
import "../../Styles/OrganisationManagement/BenutzerManagementSuperAdmin.css";
import {Col, Container, Form, Modal, Row, Button} from "react-bootstrap";
import "../../Styles/OrganisationManagement/Organisation.css";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faInfoCircle, faKey, faPlus, faTrash} from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import {
    changeUserStatus,
    getDetails,
    getUsersData,
    resetPassword,
    getcompanyinfos, logoutUser, deleteSingleUser, sendEmail
} from "../../API/user";
import {getOut} from "../../Utils/Common";
import NewUserModal from "./NewUserModal";
import UserDetailsModal from "./UserDetailsModal";
import {X} from "react-feather";



class BenutzerManagement extends React.Component {

    constructor(props) {
        super(props);
        this.onSelectedRoleChange = this.onSelectedRoleChange.bind(this);
        this.onSelectedBusinessRoleChange = this.onSelectedBusinessRoleChange.bind(this);

        this.handleModalStatusChange = this.handleModalStatusChange.bind(this);
        this.updateState = this.updateState.bind(this);
        this.updateNameForm = this.updateNameForm.bind(this);
        this.onSelectedGenderChange = this.onSelectedGenderChange.bind(this);
        this.onSelectedCompanyChange = this.onSelectedCompanyChange.bind(this);
        this.createNewUser = this.createNewUser.bind(this);

        this.deleteUser = this.deleteUser.bind(this);

        this.setErrMesssageState();
        this.state = {
            loggedInUser: this.getLoggedInUserRole(),
            companyID: null,
            displayStatus: false,
            displayRoles: true,
            allowedRoles: [],
            allowedBusinessRoles:[],
            companyinfos: [],
            userRoles: [],
            businessRoles:[],
            availableGender: [{gender: 'M', id: 1}, {gender: 'W', id: 2}, {gender: 'D', id: 3}],
            availableCompanyNames: [],
            userCompanyName: [],
            userGender: [],

            deleteUserModalShow: false,
            displayDelete: false,
            userToBeDeleted: '',

            editUserModalShow: false,
            editNewUserModalShow: false,
            tableCheckbox: false,
            initialEmail: null,
            initialContact: null,
            deleteText: null,
            editUserData: {
                items: {
                    fn: "",
                    ln: "",
                    em: "",
                    co: "",
                    cm: "",
                    r_id: "",
                    st: "",
                    ar: "",
                    ge: "",
                    status_link: "",
                    uid: "",
                    user_details: "",
                    zuruecksetzen: "",
                    cm_id: ""
                }
            }
        }
    }


    // To get the logged-in user roles from local storage
    getLoggedInUserRole = () => {
        let userRoles = sessionStorage.getItem('roles');
        let isSuperAdmin = userRoles.includes('Super-Admin');
        let isAdmin = userRoles.includes('Admin');
        let isMobilePl = userRoles.includes('Mobile-Pl');


        if (isSuperAdmin) {
            return 'superAdmin'
        } else if (isAdmin) {
            return 'Admin'
        } else if (isMobilePl) {
            return 'MobilePl'
        }{
            return 'invalidUser'
        }
    };


    ////change to status link as received link
    async handleTableStatusChange(event, link) {
        const statusLink = link.concat(Number(event.target.checked));
        const resp = await changeUserStatus(statusLink);
        if (resp.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        }
        if (resp.message === 'loggout') {
            // if the user deactivate himself...
            // we log him out :)
            await logoutUser();
            getOut('logged out');
        } else {
            setTimeout(function () {
                window.location.reload(0.5);
            }, 500);
        }
        event.preventDefault();
    }

    deleteUser = async (el, uid) => {
        if (uid === 'delete') {
            let d = await deleteSingleUser(this.state.userToBeDeleted);
            console.log(JSON.stringify(d.message))
            this.setState({userToBeDeleted: ''});
            this.setState({deleteUserModalShow: false});
            setTimeout(function () {
                window.location.reload(0.5);
            }, 500);
        } else {
            this.setState({userToBeDeleted: uid})
            this.setState({deleteUserModalShow: true})
        }
    }

    deleteUserRob = async (e) => {
        if (e.target.value === 'Endgültig löschen') {
            this.setState({displayDelete: true})
        } else {
            this.setState({displayDelete: false})
        }
    }


    createNewUser = async () => {

        const returnvalue = await getcompanyinfos();
        if (returnvalue.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        }
        const items = {
            fn: "", ln: "", em: "", co: "",
            cm: "", r_id: "", st: "", ge: "", cm_id: ""
        };
        this.setState({editUserData: {items}});
        this.setState({displayStatus: false});
        this.setState({userGender: []});
        this.setState({userRoles: []});
        this.setState({businessRoles:[]})
        this.setState({userCompanyName: []});
        this.setState({allowedRoles: []});
        this.setState({allowedBusinessRoles: returnvalue.allowed_business_roles});

        if (this.state.loggedInUser === 'Admin') {
            this.setState({allowedRoles: returnvalue.cm_ar});
            let createCompanyDataCopy = this.state.editUserData;
            createCompanyDataCopy.items["cm"] = returnvalue.all_cm[0].companyName;
            createCompanyDataCopy.items["cm_id"] = returnvalue.all_cm[0].id;
            this.setState({editUserData: createCompanyDataCopy});
        }
        this.setState({companyinfos: returnvalue});
        this.setState({availableCompanyNames: returnvalue.all_cm});
        this.setState({editNewUserModalShow: true});
        this.setErrMesssageState();
    };

    pwdzuruecksetzen = async (el, resetpwdlink,name) => {
        let items = await resetPassword(resetpwdlink);
        if (items.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        }
        let emaildetails = {
            emailtype: "passwordreset",
            emaildetails: {
                username: name,
                email: items.useremail,
                otp: items.otp,
            }
        }
        await sendEmail(emaildetails)
        setTimeout(function () {
            window.location.reload(0.5);
        }, 500);
        el.preventDefault();

    };

    openDetails = async (el, detailsLink) => {
        let items = await getDetails(detailsLink);
        if (items.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        }
        items = items.data
        this.setState({displayStatus: true});
        const uRoles = Object.entries(items["r_id"]).map(([key, value]) => ({'role': value, 'rid': key}));
        this.setState({userRoles: uRoles});
        this.setState({businessRoles:Object.entries(items["business_role"]).map(([key, value]) => ({'role': value, 'rid': key}))})
        this.setState({userGender: [items["ge"]]});
        this.setState({allowedRoles: items.allowed_roles});
        this.setState({allowedBusinessRoles: items.allowed_business_roles});


        this.setState({initialEmail: items["em"], initialContact: items["co"]});
        this.setErrMesssageState();
        this.setState({editUserData: {items}});
        this.setState({editUserModalShow: true});
        el.preventDefault();
    };


    setErrMesssageState() {
        this.setState({
            errorMessageFirstName: "",
            errorMessageLastName: "",
            errorMessageEMail: "",
            errorMessageContactNumber: "",
            errorMessageRole: "",
            errorMessageCompany: "",
            errorMessageGender: "",
        })
    }

    onSelectedRoleChange(selectedList) {
        let messageRole = "";
        if (selectedList.length === 0) {
            messageRole = "Bitte eine Rolle eintragen";
        }
        this.setState({userRoles: selectedList});
        let roleDictionary = Object.assign({}, ...selectedList.map((x) => ({[x.rid]: x.role})));
        let createRoleDataCopy = this.state.editUserData;
        createRoleDataCopy.items["r_id"] = roleDictionary;
        this.setState({editUserData: createRoleDataCopy, errorMessageRole: messageRole})
    }

    onSelectedBusinessRoleChange(selectedList) {
        let messageRole = "";
        if (selectedList.length === 0) {
            messageRole = "Bitte eine Rolle eintragen";
        }
        this.setState({businessRoles: selectedList});
        let businessroleDictionary = Object.assign({}, ...selectedList.map((x) => ({[x.rid]: x.role})));
        let createbusinessRoleDataCopy = this.state.editUserData;
        createbusinessRoleDataCopy.items["business_role"] = businessroleDictionary;
        this.setState({editUserData: createbusinessRoleDataCopy, errorMessageRole: messageRole})
    }


    onSelectedGenderChange(selectedList) {
        let messageGender = "";
        if (selectedList.length === 0) {
            messageGender = "Bitte eine Gender eintragen";
        }
        this.setState({userGender: selectedList});
        let createGenderDataCopy = this.state.editUserData;
        createGenderDataCopy.items["ge"] = selectedList[0].gender;
        this.setState({editUserData: createGenderDataCopy, errorMessageGender: messageGender})
    }

    onSelectedCompanyChange(selectedList) {
        let messageCompany = "";
        if (selectedList.length === 0) {
            messageCompany = "Bitte eine Firma eintragen";
        }
        this.setState({userCompanyName: selectedList});
        let companyDictionary = {"companyName": selectedList[0].companyName, "id": selectedList[0].id};
        let createCompanyDataCopy = this.state.editUserData;
        createCompanyDataCopy.items["cm"] = companyDictionary["companyName"];
        createCompanyDataCopy.items["cm_id"] = companyDictionary["id"];
        this.setState({editUserData: createCompanyDataCopy, errorMessageCompany: messageCompany});
        let d = this.state.companyinfos["cm_ar"]
        this.setState({allowedRoles: d[companyDictionary["id"]]});
    }

    handleModalStatusChange(e) {
        let createModalSTDataCopy = this.state.editUserData;
        createModalSTDataCopy.items["st"] = e.target.checked;
        this.setState({editUserData: createModalSTDataCopy});
    }

    updateState(e) {
        this.setState(e);
    }

    updateNameForm(dataCopy, mydict) {
        mydict['editUserData'] = dataCopy;
        this.setState(mydict);
    }


    async componentDidMount() {
        const bm_data = await getUsersData();
        if (bm_data.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        }
        const bmdatas = bm_data["users"].map(o =>
            <tr
                key={o.uid}
            >
                <td><input onChange={e => this.handleTableStatusChange(e, o.uid)}
                           className="userdetailscheckbox"
                           type="checkbox"
                           id="checkbox" defaultChecked={o.st}/></td>
                <td>{o.ln}</td>
                <td>{o.fn}</td>
                <td>{o.em}</td>
                <td>{o.co}</td>
                <td>{o.company_name}</td>
                <td>{Object.values(o.r_id).join("|")}</td>
                <td>
                    <button disabled={!o.st} onClick={(element) => this.pwdzuruecksetzen(element, o.uid,o.fn)}
                            className="passwordReset" style={{padding: 5, fontSize: 15}}
                    ><FontAwesomeIcon icon={faKey}/> Zurücksetzen
                    </button>
                </td>
                <td>
                    <button onClick={(element) => this.openDetails(element, o.uid)}
                            className="userDetails" style={{padding: 5, fontSize: 15}}>
                        <FontAwesomeIcon icon={faInfoCircle}/> Details
                    </button>
                </td>


                <td>
                    <button
                        onClick={(element) => this.deleteUser(element, o)}
                        className="userDelete" style={{padding: 5, fontSize: 15}}>
                        <FontAwesomeIcon icon={faTrash}/> Delete
                    </button>
                </td>
            </tr>
        );
        this.setState({
            bmData: bmdatas,
            companyinfos: await getcompanyinfos(),
            loggedInUser: this.getLoggedInUserRole()
        });

        // Initialises the DataTable for our User Management - Super Admin.
        let ex = $("#benutzerManagementSuperAdminTable").DataTable({
            "aLengthMenu": [[3, 5, 10, -1], [3, 5, 10, "All"]],
            "pageLength": 3,   // Shows three rows by default.
            "dom": 'frtilp',
            "language": {
                fontcolor: 'white',
                url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json'// German Language - DataTable Plugin
            },
            "oLanguage": {
                "sSearch": "",
                searchPlaceholder: "Suchen"
            },
            "columnDefs": [
                {"className": "dt-center", "targets": "_all"} // Shows data in table columns - centered.
            ],
        });


        //Visibility of deleteuser column
        let logged = this.getLoggedInUserRole()
        if (logged === 'superAdmin') {
            ex.columns([9]).visible(true);
        } else {
            ex.columns([9]).visible(false)
        }

        let _ = this
        $("#create-user-button").click(function () {
            _.createNewUser();
        });

    }

    render() {
        return (
            <>
                <div className="handwai-dark organisationBorerStyle">

                    <Container fluid>

                        {/* A Button for new user - modal. */}
                        <Row>
                            <Col md={{span: 1, offset: 11}}>
                                <button id="create-user-button" className="btn handwai-btn createUser"
                                ><FontAwesomeIcon icon={faPlus}/> Neu Benutzer
                                </button>
                            </Col>
                        </Row>

                        {/* A Table with User Management functionalities. */}
                        <Row>
                            <Col>
                                <table id="benutzerManagementSuperAdminTable" className="table">
                                    <thead>
                                    <tr>
                                        <th data-sortable="true" data-searchable="true">Status</th>
                                        <th data-sortable="true" data-searchable="true">Nachname</th>
                                        <th data-sortable="true" data-searchable="true">Vorname</th>
                                        <th data-sortable="true" data-searchable="true">Email Adresse</th>
                                        <th data-sortable="true" data-searchable="true">Handynummer</th>
                                        <th data-sortable="true" data-searchable="true">Organisation</th>
                                        <th data-sortable="true" data-searchable="true">Rolle</th>
                                        <th>Passwort</th>
                                        <th>Details</th>

                                        <th>Delete</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.bmData}
                                    </tbody>
                                </table>

                            </Col>
                        </Row>

                    </Container>

                </div>


                {/* A Modal for existing user where we can edit the information. */}
                <UserDetailsModal props={this.state} changeState={this.updateState}
                                  updateNameForm={this.updateNameForm}
                                  handleModalStatusChange={this.handleModalStatusChange}
                                  onSelectedGenderChange={this.onSelectedGenderChange}
                                  onSelectedRoleChange={this.onSelectedRoleChange}
                                  onSelectedBusinessRoleChange={this.onSelectedBusinessRoleChange}
                >

                </UserDetailsModal>


                {/* A Modal for new user where we can add the new information. */}
                <NewUserModal props={this.state} changeState={this.updateState}
                              updateNameForm={this.updateNameForm}
                              onSelectedGenderChange={this.onSelectedGenderChange}
                              onSelectedRoleChange={this.onSelectedRoleChange}
                              onSelectedCompanyChange={this.onSelectedCompanyChange}
                              onSelectedBusinessRoleChange={this.onSelectedBusinessRoleChange}>
                </NewUserModal>


                <Modal
                    size="md" aria-labelledby="contained-modal-title-vcenter"
                    centered
                    animation={false}
                    show={this.state.deleteUserModalShow}
                    onHide={() => this.setState({deleteUserModalShow: false})}
                >

                    <Modal.Header closeButton>

                        <Modal.Title>Objekte endgültig löschen?
                        </Modal.Title>

                    </Modal.Header>

                    <Modal.Body>
                        <Form.Label>Um das Löschen zu bestätigen, geben Sie Endgültig löschen in das Texteingabefeld
                            ein.</Form.Label>
                        <Form>
                            <Form.Group as={Row} controlId="deleteInput">
                                <Form.Control
                                    type="text"
                                    placeholder="Endgültig löschen"
                                    onChange={(e) => this.deleteUserRob(e)}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>


                        <Button size="sm" variant="outline-dark" style={{width: "40%"}}
                                onClick={() => this.setState({deleteUserModalShow: false})}><X/>
                            &nbsp;&nbsp;Abbrechen
                        </Button>


                        <Button style={{width: "40%"}} disabled={!this.state.displayDelete} size="sm" block
                                variant="outline-success"
                                onClick={(el) => this.deleteUser(el, 'delete')}><FontAwesomeIcon
                            icon={faTrash}/>&nbsp;&nbsp;Objekte löschen</Button>


                    </Modal.Footer>

                </Modal>
            </>
        );
    }
}

export default memo(BenutzerManagement);